import React from 'react';
import ReactCountdown from 'react-countdown';

const Timer = ({ date }) => {
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <span>¡Es hoy!</span>;
    }

    return (
      <div className="grid grid-cols-4 gap-4 md:gap-6">
        <div className="text-center">
          <div className="text-4xl md:text-5xl font-cursive">{days}</div>
          <div className="text-sm md:text-base font-serif">días</div>
        </div>
        <div className="text-center">
          <div className="text-4xl md:text-5xl font-cursive">{hours}</div>
          <div className="text-sm md:text-base font-serif">horas</div>
        </div>
        <div className="text-center">
          <div className="text-4xl md:text-5xl font-cursive">{minutes}</div>
          <div className="text-sm md:text-base font-serif">minutos</div>
        </div>
        <div className="text-center">
          <div className="text-4xl md:text-5xl font-cursive">{seconds}</div>
          <div className="text-sm md:text-base font-serif">segundos</div>
        </div>
      </div>
    );
  };

  return (
    <ReactCountdown
      date={date}
      renderer={renderer}
    />
  );
};

export default Timer; 